<div class="flex-card item-card bg-container bg-container-fill item-border-radius bg-no-filter-animate"
  [photoBg]="{fade: true, fadeClass: 'bg-container-fade', url: data ? photoUrl: photoUrl}">
  <div class="content" fxLayout="column">
    <ion-grid class="full-w grid-center-absolute">
      <ion-row>
        <ion-col size="12">
          <span *ngIf="itemName" class="info-text-s bold text-color-overlay-s">{{itemName}}</span>
        </ion-col>
      </ion-row>
      <ion-row class="padding-null">
        <ion-col size="2">

        </ion-col>
        <ion-col size="8" class="self-center">
          <span *ngIf="isReference" class="info-text-xs bold text-color-overlay-s">reference</span>
          <span *ngIf="!isReference" class="info-text-xs bold text-color-overlay-s">uploaded</span>
        </ion-col>
        <ion-col size="2">
          <div *ngIf="!isReference" class="ion-float-right leplace-icon-m icon-color-accent">
            <icon-wrapper [icon]="appIcons.check" [custom]="true"></icon-wrapper>
          </div>
        </ion-col>
      </ion-row>

    </ion-grid>
  </div>
</div>